(function () {
  var SAVE_DEBOUNCE_MS = 250;
  var PHONE_MIN_LENGTH = 6;

  function normalize(value) {
    return (value || '').trim();
  }

  function debounce(fn, wait) {
    var timeout;

    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function getCartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/update.js';
    }

    return '/cart/update.js';
  }

  function saveAttributes(attributes) {
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function getSelectedRecipientMode(context) {
    var checkedOption = context.recipientModeInputs.find(function (input) {
      return input.checked;
    });

    return checkedOption ? checkedOption.value : 'self';
  }

  function getCheckedRecipientOption(context) {
    return context.recipientModeInputs.find(function (input) {
      return input.checked;
    });
  }

  function isPhoneValid(value) {
    return normalize(value).length >= PHONE_MIN_LENGTH;
  }

  function getContext(root, config) {
    return {
      phoneWrapper: root.querySelector(config.phoneWrapperSelector),
      phoneInput: root.querySelector(config.phoneInputSelector),
      phoneHidden: root.querySelector(config.phoneHiddenSelector),
      phoneError: root.querySelector(config.phoneErrorSelector),
      checkoutButton: root.querySelector(config.checkoutSelector),
      recipientRoot: root.querySelector('[data-cart-recipient-root]'),
      recipientFields: root.querySelector('[data-recipient-fields]'),
      recipientError: root.querySelector('[data-recipient-error]'),
      recipientOptions: Array.from(root.querySelectorAll('[data-recipient-option]')),
      recipientModeInputs: Array.from(root.querySelectorAll('[data-recipient-mode]')),
      recipientInputs: Array.from(root.querySelectorAll('[data-recipient-input]')),
      recipientTypeHidden: root.querySelector('[data-recipient-type-attr]'),
      attributeInputs: Array.from(root.querySelectorAll('[data-cart-attribute-key]'))
    };
  }

  function setRecipientFieldState(context, mode) {
    var showRecipientFields = mode === 'other';

    if (context.recipientFields) {
      context.recipientFields.hidden = !showRecipientFields;
    }

    context.recipientOptions.forEach(function (option) {
      var radio = option.querySelector('[data-recipient-mode]');
      option.classList.toggle('is-selected', Boolean(radio && radio.checked));
    });

    context.recipientInputs.forEach(function (input) {
      input.disabled = !showRecipientFields;
    });
  }

  function syncRecipientFields(context) {
    if (!context.recipientRoot || !context.recipientTypeHidden) return;

    var mode = getSelectedRecipientMode(context);
    var checkedOption = getCheckedRecipientOption(context);
    var selectedAttributeValue = checkedOption ? checkedOption.dataset.recipientAttributeValue : 'Acquirente';

    setRecipientFieldState(context, mode);
    context.recipientTypeHidden.value = selectedAttributeValue;

    context.recipientInputs.forEach(function (input) {
      var targetId = input.dataset.cartSyncTarget;
      if (!targetId) return;

      var hiddenTarget = document.getElementById(targetId);
      if (!hiddenTarget) return;

      hiddenTarget.value = mode === 'other' ? normalize(input.value) : '';
    });
  }

  function syncPhoneField(context) {
    if (!context.phoneInput || !context.phoneHidden) return;
    context.phoneHidden.value = normalize(context.phoneInput.value);
  }

  function updateAttributeInputs(context) {
    syncPhoneField(context);
    syncRecipientFields(context);
  }

  function validatePhone(context, touched) {
    if (!context.phoneInput || !context.phoneHidden || !context.checkoutButton) return true;
    if (context.phoneInput.disabled) return true;

    var phoneIsValid = isPhoneValid(context.phoneInput.value);

    if (context.phoneError) {
      context.phoneError.style.display = touched && !phoneIsValid ? 'block' : 'none';
    }

    context.phoneInput.setAttribute('aria-invalid', touched && !phoneIsValid ? 'true' : 'false');

    return phoneIsValid;
  }

  function validateRecipient(context, touched) {
    if (!context.recipientRoot) return true;

    var mode = getSelectedRecipientMode(context);
    var invalidInputs = [];

    context.recipientInputs.forEach(function (input) {
      var isRequired = input.dataset.recipientRequired === 'true';
      var isInvalid = mode === 'other' && isRequired && !normalize(input.value);

      input.setAttribute('aria-invalid', touched && isInvalid ? 'true' : 'false');

      if (isInvalid) invalidInputs.push(input);
    });

    if (context.recipientError) {
      context.recipientError.style.display = touched && invalidInputs.length ? 'block' : 'none';
    }

    return invalidInputs.length === 0;
  }

  function updateUI(root, config) {
    var context = getContext(root, config);
    var state = root.__cartContactState || { phoneTouched: false, recipientTouched: false };

    updateAttributeInputs(context);

    var phoneIsValid = validatePhone(context, state.phoneTouched);
    var recipientIsValid = validateRecipient(context, state.recipientTouched);

    if (context.checkoutButton && !(context.phoneInput && context.phoneInput.disabled)) {
      context.checkoutButton.disabled = !phoneIsValid || !recipientIsValid;
    }
  }

  function collectAttributes(root, config) {
    var context = getContext(root, config);
    var attributes = {};

    updateAttributeInputs(context);

    context.attributeInputs.forEach(function (input) {
      var key = input.dataset.cartAttributeKey;
      if (!key) return;
      attributes[key] = input.value;
    });

    return attributes;
  }

  function persistAttributes(root, config) {
    var attributes = collectAttributes(root, config);
    return saveAttributes(attributes).catch(function () {});
  }

  function getFirstInvalidInput(root, config) {
    var context = getContext(root, config);

    if (context.phoneInput && context.phoneInput.disabled === false && !isPhoneValid(context.phoneInput.value)) {
      return context.phoneInput;
    }

    var mode = getSelectedRecipientMode(context);
    if (mode !== 'other') return null;

    return (
      context.recipientInputs.find(function (input) {
        return input.dataset.recipientRequired === 'true' && !normalize(input.value);
      }) || null
    );
  }

  function belongsToContext(target, context, config) {
    if (!target) return false;

    if (target.matches(config.phoneInputSelector)) return true;
    if (target.matches('[data-recipient-mode]')) return true;
    if (target.matches('[data-recipient-input]')) return true;

    return false;
  }

  function bindContext(root, config) {
    if (!root || root.__cartContactBound) return;

    root.__cartContactBound = true;
    root.__cartContactState = root.__cartContactState || { phoneTouched: false, recipientTouched: false };
    root.__cartContactSave = debounce(function () {
      persistAttributes(root, config);
    }, SAVE_DEBOUNCE_MS);

    updateUI(root, config);

    root.addEventListener('input', function (event) {
      var context = getContext(root, config);
      if (!belongsToContext(event.target, context, config)) return;

      if (event.target.matches(config.phoneInputSelector)) {
        root.__cartContactState.phoneTouched = true;
      }

      if (event.target.matches('[data-recipient-input]')) {
        root.__cartContactState.recipientTouched = true;
      }

      updateUI(root, config);
      root.__cartContactSave();
    });

    root.addEventListener('change', function (event) {
      var context = getContext(root, config);
      if (!belongsToContext(event.target, context, config)) return;

      if (event.target.matches(config.phoneInputSelector)) {
        root.__cartContactState.phoneTouched = true;
      }

      if (event.target.matches('[data-recipient-mode], [data-recipient-input]')) {
        root.__cartContactState.recipientTouched = true;
      }

      updateUI(root, config);

      if (event.target.matches('[data-recipient-mode]')) {
        persistAttributes(root, config);
        return;
      }

      root.__cartContactSave();
    });

    root.addEventListener('focusout', function (event) {
      var context = getContext(root, config);
      if (!belongsToContext(event.target, context, config)) return;

      if (event.target.matches(config.phoneInputSelector)) {
        root.__cartContactState.phoneTouched = true;
      }

      if (event.target.matches('[data-recipient-mode], [data-recipient-input]')) {
        root.__cartContactState.recipientTouched = true;
      }

      updateUI(root, config);
      persistAttributes(root, config);
    });

    root.addEventListener('click', function (event) {
      var checkoutButton = event.target.closest(config.checkoutSelector);
      if (!checkoutButton) return;

      root.__cartContactState.phoneTouched = true;
      root.__cartContactState.recipientTouched = true;

      updateUI(root, config);

      var invalidInput = getFirstInvalidInput(root, config);
      if (invalidInput) {
        event.preventDefault();
        event.stopPropagation();
        invalidInput.focus();
        return;
      }

      try {
        persistAttributes(root, config);
      } catch (error) {}
    });

    root.__cartContactObserver = new MutationObserver(function () {
      updateUI(root, config);
    });
    root.__cartContactObserver.observe(root, { childList: true, subtree: true });
  }

  function init() {
    bindContext(document.getElementById('main-cart-footer'), {
      phoneWrapperSelector: '[data-phone-wrapper]',
      phoneInputSelector: '#CartPhone',
      phoneHiddenSelector: '#CartPhoneAttr',
      phoneErrorSelector: '#CartPhoneError',
      checkoutSelector: 'button[name="checkout"]#checkout'
    });

    bindContext(document.querySelector('cart-drawer'), {
      phoneWrapperSelector: '[data-phone-wrapper]',
      phoneInputSelector: '#CartDrawerPhone',
      phoneHiddenSelector: '#CartDrawerPhoneAttr',
      phoneErrorSelector: '#CartDrawerPhoneError',
      checkoutSelector: '#CartDrawer-Checkout'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart:refresh', init);
})();
